import { SIGN, SIGN_FONT } from "../theme";
import { APP_PATH } from "../Layers/layerBasics";

// The trackmystreet logo, shared by the landing page and the map app: the name on a
// British street nameplate (white plate, black border, "UK" in red where a sign has its
// postcode district). It's drawn as text so it stays sharp at any size.
// markOnly shows the small square sign mark instead, for the phone header where search
// takes the room. The same mark is the favicon (public/favicon.svg).
export const SignMark = ({size=26}) => (
    <svg width={size} height={size} viewBox="0 0 64 64" aria-hidden="true" style={{display:'block', flexShrink:0}}>
        <rect width="64" height="64" rx="14" fill={SIGN.ink}/>
        <rect x="7" y="16" width="50" height="32" rx="5" fill={SIGN.plate}/>
        <rect x="11" y="20" width="42" height="24" rx="2.5" fill="none" stroke={SIGN.ink} strokeWidth="2.5"/>
        <rect x="17" y="27" width="30" height="5" rx="1" fill={SIGN.ink}/>
        <rect x="26" y="35" width="12" height="3.5" rx="1" fill={SIGN.red}/>
    </svg>
);

const Logo = ({isMobile, markOnly=false}) => markOnly ? (
    <a href={APP_PATH + '/'} aria-label="trackmystreet home" className="logo logo-mark"
        style={{display:'inline-flex', alignItems:'center', textDecoration:'none', lineHeight:1}}>
        <SignMark size={isMobile ? 26 : 30}/>
    </a>
) : (
    <a href={APP_PATH + '/'} aria-label="trackmystreet home" className="logo logo-sign"
        style={{display:'inline-flex', alignItems:'baseline', gap:'.45em', textDecoration:'none',
            background:SIGN.plate, color:SIGN.ink, border:'2.5px solid '+SIGN.ink, borderRadius:5,
            boxShadow:'0 0 0 2px '+SIGN.plate+', 0 0 0 3px '+SIGN.edge,
            padding:'.32em .6em .26em', margin:3,
            fontFamily:SIGN_FONT, fontWeight:700, fontSize:isMobile ? 15 : 18, letterSpacing:'.05em',
            lineHeight:1, whiteSpace:'nowrap'}}>
        <span>TRACK MY STREET</span>
        <span style={{color:SIGN.red, fontSize:'.62em', letterSpacing:'.16em'}}>UK</span>
    </a>
);

export default Logo;
